<template>
    <v-app>
        <app-header v-if="showMainBars"
        @onShowNotificationPanel="onShowNotificationPanel"
        @onShowUserSettingsDialog="onShowUserSettingsDialog"
        ></app-header>

       <application-access-panel  v-if="showMainBars"></application-access-panel>

        <v-content v-if="!showProgressBar" class="contentPage">
          <router-view />
        </v-content>

        <v-btn
            v-show="showBackBtn && showMainBars"
            fab
            white
            fixed
            top
            x-small
            left
            style="left:65px;top:88px"
            color="primary"
            @click="goback"
          >
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>

        <v-btn
            v-scroll="onScroll"
            v-show="backToTop && showMainBars"
            fab
            white
            fixed
            bottom
            x-small
            left
            color="primary"
            style="left:60px;bottom:50px"
            @click="toTop"
          >
            <v-icon>keyboard_arrow_up</v-icon>
        </v-btn>

        <app-footer v-if="showMainBars"></app-footer>

        <app-settings-dialog
                v-if="show_setting_dlg"
                v-model="show_setting_dlg"
                :userPreferencesDetails="userPreferencesDetails"
                @logout="logout"
                @showAdminGroupsPage="showAdminGroupsDlg"
                @showUserPreferenceDialog="showUserPreferenceDialog">
        </app-settings-dialog>

        <main-progress-bar
            :show_progress_bar="showProgressBar"
            color_progress_bar="primary"
        ></main-progress-bar>
        <app-snack-bar
            v-if="snackbarDetails.show"
            :showSnackbar="snackbarDetails.show"
            :snackbarDetails="snackbarDetails"
      ></app-snack-bar>
    <v-overlay :value="processingOverlay" class="mainOverlay">
      <v-progress-circular indeterminate color="primary" size="150" width="6"></v-progress-circular>
    </v-overlay>
    <app-confirm-dialog
        v-if="confirmDialogDetails.showDlg"
        :showDlg="confirmDialogDetails.showDlg"
        :title="confirmDialogDetails.title"
        :message="confirmDialogDetails.message"
        :buttons="confirmDialogDetails.buttons"
        :maxWidth="confirmDialogDetails.maxWidth"
        :submitCallback="confirmDialogDetails.submitCallback"
        :cancelCallback="confirmDialogDetails.cancelCallback"
        :type="confirmDialogDetails.type"
    ></app-confirm-dialog>
    <admin-groups-dialog
            v-if="show_admin_group_dlg"
            v-model="show_admin_group_dlg"
            :admins="adminsList"       
            :internalUsers="internalUsers"
            @closeSettingDialog="closeSettingDialog">
        ></admin-groups-dialog>
        <user-preferences-dialog
            v-if="user_preferences_dialog"
            v-model="user_preferences_dialog"
            :user_preferences_details="user_preferences_details"
            @closeSettingDialog="closeSettingDialog">
        </user-preferences-dialog>
        <notification-panel
            v-model="show_notification_panel"
            @openNotification="openNotification"
            @showAllNotifications="showAllNotifications"
        ></notification-panel>
         <communication-more-dialog
            v-if="showCommunication"
            :value="showCommunication"
            :item="communicationDetail">
        </communication-more-dialog>
  </v-app>
</template>

<script>
    import UserPreferencesDialog from "@/dialogs/user-preferences-dialog";
    import AdminGroupsDialog from '@/dialogs/admin-groups-dialog';
    import loadImageMixin from "@/mixins/loadImageMixin";
    import AppSettingsDialog from "@/dialogs/app-settings-dialog";
    import ApplicationAccessPanel from "@/components/AppPage/ApplicationAccessPanel";
    import AppFooter from "@/components/AppPage/AppFooter";
    import AppHeader from "@/components/AppPage/AppHeader";
    import ProgressBar from "@/components/ProgressBar";
    import AppSnackBar from "@/components/AppSnackBar";
    import Encryption from "@/common/encryption";
    import AppConfirmDialog from "@/dialogs/app-confirm-dialog";
    import NotificationPanel from "@/dialogs/notifications-panel.vue";    
    import CommunicationMoreDialog from "@/dialogs/communication-more-dialog";

export default {
    name: 'App',
    mixins: [loadImageMixin],
    components: {
        "app-settings-dialog": AppSettingsDialog,
        "main-progress-bar": ProgressBar,
        "application-access-panel":ApplicationAccessPanel,
        "app-footer":AppFooter,
        "app-header":AppHeader,
        "app-snack-bar":AppSnackBar,
        "app-confirm-dialog":AppConfirmDialog,
        "admin-groups-dialog":AdminGroupsDialog,
        "user-preferences-dialog": UserPreferencesDialog,
        "notification-panel":NotificationPanel,
        "communication-more-dialog": CommunicationMoreDialog
    },
    data() {
        return {
            show_setting_dlg: false,
            main_bars: false,
            state:"",
            backToTop:false,
            userPreferencesDetails: null,
            show_admin_group_dlg: false,
            adminsList: null,
            internalUsers: null,
            user_preferences_dialog: false,
            user_preferences_details: [],
            show_notification_panel:false
        };
    },
    computed: {
        showProgressBar() {
            return this.$store.getters.getProgressBar;
        },
        showMainBars(){
           return this.$route.name != "ErrorPage" && this.main_bars;
        },
        showBackBtn(){
            return this.$route.path != "/";
        },
        snackbarDetails() {
            return this.$store.getters.getSnackbarDetails;
        },
        processingOverlay(){
            return this.$store.getters.getProcessingOverlay;
        },
        confirmDialogDetails(){
            return this.$store.getters.getConfirmDialogDetails;
        },
        showCommunication(){
            return this.$store.getters.getShowCommunication;
        },
        communicationDetail(){
            return this.$store.getters.getCommunicationDetail;
        }
    },
    created() {   
        this.$store.dispatch("setProgressBar", true);
        this.main_bars = false;
        this.$store.dispatch("initializeUserAuthState");
        this.ssoValidations();
    },
    mounted(){
        //customize v-dialog moveable
        const d = {};
        document.addEventListener("mousedown", e => {
            const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
            if (e.button === 0 && closestDialog != null && e.target.classList.contains("v-card__title")) { // element which can be used to move element
                d.el = closestDialog; // element which should be moved
                d.mouseStartX = e.clientX;
                d.mouseStartY = e.clientY;
                d.elStartX = d.el.getBoundingClientRect().left;
                d.elStartY = d.el.getBoundingClientRect().top;
                d.el.style.position = "fixed";
                d.el.style.margin = 0;
                d.oldTransition = d.el.style.transition;
                d.el.style.transition = "none"
            }
        });
        document.addEventListener("mousemove", e => {
            if (d.el === undefined) {
                return;
            }
            d.el.style.left = Math.min(
                Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
                window.innerWidth - d.el.getBoundingClientRect().width
            ) + "px";
            d.el.style.top = Math.min(
                Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
                window.innerHeight - d.el.getBoundingClientRect().height
            ) + "px";
        });
        document.addEventListener("mouseup", () => {
            if (d.el === undefined) {
                return;
            }
            d.el.style.transition = d.oldTransition;
            d.el = undefined;
        });
        setInterval(() => { // prevent out of bounds
            const dialog = document.querySelector(".v-dialog.v-dialog--active");
            if (dialog === null) {
                return;
            }
            dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
            dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
            }, 100);
    },
    methods: {
        initState() {
            const crypto = window.crypto || window.msCrypto;
            const array = new Uint32Array(1);
            const randomStr = crypto.getRandomValues(array)[0]; 
            sessionStorage.setItem("state", randomStr);
            this.state = randomStr;
        },
        validateState() {
            const state = sessionStorage.getItem("state");
            const state1 = this.$route.query.state;
            if (state === state1) {
                sessionStorage.removeItem("state");
                return true;
            }
            return false;
        },
        showSnackBarInfo(msg) {
            const snackbarObj = {
                msg,
                show: true,
                timeout: 6000,
                close: () => {
                this.$store.dispatch("setProgressBar", true);
                const logOutUri = this.$store.getters.getConfig.logoutUri;
                this.$store.dispatch("logout").then(() => {
                    sessionStorage.clear();
                    window.location = `${logOutUri}`;
                });
                }
            };
            setTimeout(snackbarObj.close, 7000);
            this.$store.dispatch("setSnackbarDetails", snackbarObj);
        },
        ssoValidations() {
            if (this.$route.query.code && this.$route.query.client_id && this.validateState()) {
                this.$store
                .dispatch("setAuthToken", {
                    code: this.$route.query.code,
                    client_id: this.$route.query.client_id
                })
                .then(response => {
                    if (response) {
                    this.encryption = new Encryption(
                        this.$store.getters.getConfig["rsi_services"]
                    );
                    // encrypt token
                    this.encryption.storeDataWithEncrypt(
                        this.$store.getters.getConfig["rsi_user"],
                        response.access_token
                    );
                    this.encryption.storeDataWithEncrypt(
                        this.$store.getters.getConfig["rsi_token"],
                        response.refresh_token
                    );
                    this.setAppConfigs();
                    } else {
                    this.showSnackBarInfo(`Incorrect User Details`);
                    }
                });                
            } else if (!this.$store.getters.getAuthToken) {
                this.initState();
                window.location = this.$store.getters.getConfig.oauth_authorization_url +
                "?response_type=code&client_id=" +
                this.$store.getters.getConfig.client_id +
                "&scope=profile&redirect_uri=" +
                this.$store.getters.getConfig.redirect_uri +
                "&state=" +
                this.state;
            } else {
                this.setAppConfigs();
            }
        },
        setAppConfigs() {
            this.$store.dispatch("introspectToken").then(response => {
                console.log(response);
                //accessToken expired
                if(response.active == false){
                     this.initState();
                    window.location = this.$store.getters.getConfig.oauth_authorization_url +
                    "?response_type=code&client_id=" +
                    this.$store.getters.getConfig.client_id +
                    "&scope=profile&redirect_uri=" +
                    this.$store.getters.getConfig.redirect_uri +
                    "&state=" +
                    this.state;
                }else{
                    this.$store.dispatch("setLeftBarItems",this.$store.getters.getUserId).then(()=>{
                        this.main_bars = true;
                        this.$store.dispatch("setProgressBar", false);
                        //this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
                     }
                    );
                }
            });
           
        },
        logout(){
            const logout_redirect_url =
                this.$store.getters.getConfig.oauth_authorization_url +
                "?response_type=code&client_id=" +
                this.$store.getters.getConfig.client_id +
                "&scope=profile&redirect_uri=" +
                this.$store.getters.getConfig.redirect_uri;
                const logOutUri =  this.$store.getters.getConfig.auth_logout_url +
                "?goto=" +
                encodeURIComponent(logout_redirect_url);
                sessionStorage.clear();
                window.location = logOutUri;
        },
        onShowNotificationPanel() {
            console.log('onShowNotificationPanel(!!!)');
            this.show_notification_panel = true;
        },
        async openNotification(item){
            this.show_notification_panel = false;
            console.log(item);
            const response = await this.$store.dispatch("getNotificationBody",{userId:this.$store.getters.getUserId,commId:item.id,isBodyRequired:true});
            if(response && !response.error){
                const comm = {};
                comm.title = item.title;
                comm.body = response.body;
                this.$store.dispatch("setCommunicationDetail",comm);
                this.$store.dispatch("setShowCommunication",true);
                //refresh notification list
                this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
            }
        },
        showAllNotifications(){
            this.show_notification_panel = false;
            this.$router.push({name:"CommunicaionManagement",params:{showNotification:true}});
        },
        onShowUserSettingsDialog() {
            console.clear();
            console.log("onShowUserSettingsDialog()");
            this.show_setting_dlg = true;
        },        
        onScroll (e) {
        if (typeof window === 'undefined') {
            return
        }
            const top = window.pageYOffset ||   e.target.scrollTop || 0;
            this.backToTop = top > 20
        },
        toTop () {
            this.$vuetify.goTo(0)
        },
        goback(){            
            if(window.history.length > 2){
                if(this.$router.history.current.name =="CommunicaionManagement"){
                    this.$router.push("/");
                }else{
                    this.$router.go(-1) ;
                }
               
            }else{
                this.$router.push("/");
             
            }
        },
            showAdminGroupsDlg(properties){
                this.show_admin_group_dlg = properties.admin_dlg;
                this.adminsList = properties.admin_list;
                this.internalUsers = properties.internal_users;
            },
            closeSettingDialog(){
                this.show_setting_dlg = false;
            },
            showUserPreferenceDialog(properties){
                this.user_preferences_details=properties.user_preferences_details;
                this.user_preferences_dialog=properties.user_preferences_dlg;
            }, 
        }

    }
</script>

<style lang="scss">

    .tool-bar-action-btn.v-btn--active {
        .v-btn__content {
            .v-icon {
                color: #ff9800 !important;
            }
        }
    }


    .avatar-tool-bar {
        text-align: center;
        //margin-top: -9px;
        &:hover {
            cursor: pointer;
        }
    }

    .combo-box-domain {
        top: 9px;
        flex: inherit !important;
        width: 96px;
        right: 42px;
    }

    .text-field-search-header {
        margin-top: 16px !important;
        flex: inherit !important;
        width: 240px;
        margin-right: 81px !important;
    }

    //global css

    //global font size
    .contentPage{
        font-size: 14px !important;
    }

    //menu font size
    .v-list-item__title{
        font-size: 14px !important;
    }

    //data table font size
    .v-data-table td{
        font-size: 12px !important;
    }

    //data table header color
    .table-headers{
        background:lightgray !important;
        height:30px !important; 
    }

    //set overlay z-index
    .mainOverlay{
        z-index: 999 !important;
    }

</style>
